import React from 'react';

const DownloadsPage = () => {
  const resources = [
    {
      id: 1,
      title: 'National Action Plan for Mercury elimination (NAP)',
      description:
        'Comprehensive national action plan outlining Suriname\'s strategy for mercury reduction and elimination in the artisanal and small-scale gold mining sector, in compliance with the Minamata Convention.',
      category: 'Policy Documents',
      fileType: 'PDF',
      size: '2.2 MB',
      downloadUrl: '/downloads/Suriname-NAP-2024-EN.pdf'
    },
    {
      id: 2,
      title: 'RENFORESAP Project - Illegal Gold Mining Study',
      description:
        'Detailed project document addressing illegal gold mining (orpaillage illegal/illegale goudwinning) challenges, environmental impacts, and sustainable solutions for the forestry sector in Suriname.',
      category: 'Research & Studies',
      fileType: 'PDF',
      size: '11.6 MB',
      downloadUrl: '/downloads/RENFORESAP-Illegal-Gold-Mining.pdf'
    }
  ];

  return (
    <div data-testid="downloads-page">
      <section 
        className="section-spacing text-white relative bg-cover bg-center"
        style={{ 
          backgroundImage: 'url(/downloads-header.jpg)',
          minHeight: '305px'
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="content-container relative z-10">
          <h1 className="font-rubik text-4xl md:text-5xl font-bold text-center mb-4" data-testid="downloads-title">
            DOWNLOADS & RESOURCES
          </h1>
          <p className="font-roboto text-lg text-center max-w-3xl mx-auto">
            Access our collection of policy documents, research studies, and guides to support your sustainable
            development initiatives in Suriname and the Guiana Shield.
          </p>
        </div>
      </section>

      <section className="section-spacing bg-white">
        <div className="content-container">
          <div className="grid grid-cols-1 gap-6">
            {resources.map((resource) => (
              <div
                key={resource.id}
                className="bg-[#f5f5f5] p-6 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:shadow-md transition-shadow duration-300"
                data-testid={`resource-${resource.id}`}
              >
                <div className="flex-1">
                  <div className="mb-2">
                    <span className="inline-block bg-[#aaae10] text-white px-3 py-1 rounded-full font-roboto text-xs font-medium mr-2">
                      {resource.category}
                    </span>
                    <span className="inline-block bg-[#646464] text-white px-3 py-1 rounded-full font-roboto text-xs font-medium">
                      {resource.fileType} • {resource.size}
                    </span>
                  </div>
                  <h2 className="font-rubik text-xl font-bold mb-2 text-[#646464] uppercase">
                    {resource.title}
                  </h2>
                  <p className="font-roboto text-base leading-relaxed">
                    {resource.description}
                  </p>
                </div>
                <a
                  href={resource.downloadUrl}
                  download
                  className="btn-primary whitespace-nowrap"
                  data-testid={`download-${resource.id}`}
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-spacing bg-[#646464] text-white">
        <div className="content-container text-center">
          <h2 className="font-rubik text-3xl font-bold mb-4">
            NEED CUSTOM RESOURCES OR TRAINING?
          </h2>
          <p className="font-roboto text-lg mb-6 max-w-2xl mx-auto">
            We can develop tailored materials, training programs, and tools specific to your
            organization's needs and context.
          </p>
          <a href="/contact" className="btn-primary" data-testid="downloads-cta-button">
            Request Custom Resources
          </a>
        </div>
      </section>
    </div>
  );
};

export default DownloadsPage;
